import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import StatusLayout from "./StatusLayout";
import { useCase } from "../../context/CaseContext";
import { downloadGenericResult, submitCloseCase } from "../../lib/everifyStatusApi";
import { useClosureReasons } from "../../hooks/everify/useClosureReasons";

const TechnicalIssuePage = () => {
  const { activeCaseNumber } = useCase();
  const navigate = useNavigate();
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const {
    data: reasons = [],
    isLoading: reasonsLoading,
  } = useClosureReasons(activeCaseNumber);


  const handleSubmit = async () => {
    if (!selectedReason) {
      toast.error("Please select a reason to close the case.");
      return;
    }
    try {
      setIsSaving(true);
      await submitCloseCase(activeCaseNumber, {
        case_closure_reason_code: selectedReason,
      });
      toast.success("Case closed successfully.");
      navigate("/");
    } catch (error) {
      toast.error("Unable to close the case.");
    } finally {
      setIsSaving(false);
    }
  };

  const handleDownloadResult = async () => {
    if (!activeCaseNumber) {
      toast.error("No active case available.");
      return;
    }
    try {
      setDownloadLoading(true);
      await downloadGenericResult(activeCaseNumber, `technical-issue-${activeCaseNumber}.pdf`);
    } catch (error) {
      toast.error("Unable to download the result.");
    } finally {
      setDownloadLoading(false);
    }
  };

  const footerActions = [
  ];

  return (
    <StatusLayout
      title="Technical Issue Occurred"
      description="E-Verify requires this case to be closed due to technical issue, Please create a new case."
      footerActions={footerActions}
    >
      <div className="status-section">
        <h3>Next Steps</h3>
        <p>Select a reason that applies to this case and close it.</p>
        <label>
          Close Case Reason
          {reasonsLoading ? (
            <div className="status-loader">
              <span className="status-spinner" aria-hidden="true" />
              Loading reasons...
            </div>
          ) : (
            <select value={selectedReason} onChange={(event) => setSelectedReason(event.target.value)}>
              <option value="">Select a reason</option>
              {reasons.map((reason) => (
                <option
                  key={reason.code || reason.value || reason}
                  value={reason.code || reason.value || reason}
                >
                  {reason.name || reason.label || reason.description || reason}
                </option>
              ))}
            </select>
          )}
        </label>
        <div className="status-actions">
          <button className="status-primary" onClick={handleSubmit} disabled={isSaving}>
            {isSaving ? "Closing..." : "Close Case"}
          </button>
        </div>
      </div>
    </StatusLayout>
  );
};

export default TechnicalIssuePage;
